import { EditIcon, CopyIcon, DeleteIcon } from '@chakra-ui/icons';

export const columnsDataServices = [
  {
    Header: 'Nombre',
    accessor: 'name',
  },
  {
    Header: 'Modelos',
    accessor: 'serviceModels',
  },
  {
    Header: 'Eventos',
    accessor: 'servicesEvents.length',
  },
  {
    Header: 'Productos asociados',
    accessor: 'recommendedProducts.length',
  },
  {
    Header: 'Marca',
    accessor: 'brand.name',
  },
  {
    Header: 'Costo Volkswagen (UYU)',
    accessor: 'volkswagenCost',
  },
  {
    Header: '',
    accessor: 'actions',
    actions: [
      {
        label: 'Copiar',
        icon: <CopyIcon />,
        colorScheme: 'blue',
        type: 'copy',
      },
      {
        label: 'Editar',
        icon: <EditIcon />,
        colorScheme: 'blue',
        type: 'edit',
      },
      {
        label: 'Eliminar',
        icon: <DeleteIcon />,
        colorScheme: 'red',
        type: 'delete',
      },
    ],
  },
];
